import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {RadioInput} from 'src/app/model/structured-content-models';
import {FieldConfiguration} from '../../../../model/field-configuration';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss']
})
export class RadioComponent implements OnInit {

  @Input() radioConfig: RadioInput;
  @Input() fields: {};
  @Input() disabled: boolean;
  @Output() changed = new EventEmitter();

  public trustedHtmlContent: SafeHtml;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.trustedHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.radioConfig.infoText.content);
  }

  onChange(e: any) {
    (this.fields[this.radioConfig.fieldName] as FieldConfiguration).value = e.target.value;

    if (this.changed) {
      this.changed.emit(null);
    }
  }

  getFieldConfig(): FieldConfiguration {
    return (this.fields[this.radioConfig.fieldName] as FieldConfiguration);
  }

  isVisible(): boolean {
    return (this.fields[this.radioConfig.fieldName] as FieldConfiguration).visible;
  }
}
